/**
 * Handlebars Helpers - Deprecated wrapper
 * 
 * Use handlebars-manager.js instead
 * This file is maintained for backward compatibility only
 */

import { 
  initializeHandlebarsHelpers, 
  clearTemplateCache,
  getCacheStats
} from './handlebars-manager.js';
import debug from '@commons-shared/debug.js';
import { config } from '../config/environment.js';

// Re-export as aliases for backward compatibility
let isInitialized = false;

/**
 * Initialize Handlebars (deprecated)
 * Use initializeHandlebarsHelpers from handlebars-manager instead
 * @deprecated Use initializeHandlebarsHelpers from handlebars-manager
 */
export const initializeHandlebars = async () => {
  if (isInitialized) {
    debug.log(config, '[Deprecated] Handlebars already initialized');
    return;
  }

  try {
    debug.log(config, '[Deprecated] initializeHandlebars() called, delegating to handlebars-manager');
    await initializeHandlebarsHelpers();
    isInitialized = true;
  } catch (error) {
    debug.error(config, '[Deprecated] Error initializing Handlebars:', error);
    throw error;
  }
};

/**
 * Get Handlebars instance (deprecated)
 * @deprecated Use handlebars-manager functions instead
 */
export const getHandlebarsInstance = () => {
  if (!isInitialized) {
    throw new Error('Call initializeHandlebars() first');
  }
  // This function returns Handlebars from handlebars-manager
  // But we don't expose it directly anymore
  throw new Error('getHandlebarsInstance is deprecated. Use handlebars-manager functions instead.');
};

/**
 * Check if initialized (deprecated)
 * @deprecated Use handlebars-manager instead
 */
export const isHandlebarsInitialized = () => {
  return isInitialized;
};

// Re-export utility functions
export { clearTemplateCache, getCacheStats };

export default {
  initializeHandlebars,
  getHandlebarsInstance,
  isHandlebarsInitialized,
  clearTemplateCache,
  getCacheStats
};
